<main
  [attr.data-testid]='"rs-message-handler-" + data?.type'
  [attr.data-cy]='"rs-message-handler-" + data?.type'
  [style.display]="state().value === 'inactive' ? 'none' : ''"
>
  @if (data?.type === 'success') {
  <mat-icon class="me-20px">thumb_up</mat-icon>
  }

  <div
    data-testid="rs-message-handler-msg"
    class='rs-message-handler-msg'
  >
    @if (msgKey) {
    <span>{{ msgKey | translate: msgParams }}</span>
    } @else if (msg) {
    <span [innerHTML]="msg"></span>
    }

    <!-- BE array list of errors -->
    @if (data?.type == 'errors-array') {
    <ul
      [class.mt-10px]='msg'
      [class.no-list-type]="data?.listOfErrors?.length == 1"
      class="be-errors-list"
    >
      @for (error of data?.listOfErrors; track error) {
      <li>
        {{ ((error.translations || {}) | rsTranslate) || ('ERROR_MSG.GLOBAL' | translate) }}
        @if (error.errorId) {
        <div class='error-id rs-font-size-11px'>
          {{ 'ERROR_MSG.ERROR_ID' | translate }}: {{ error.errorId }}
        </div>
        }
      </li>
      }
    </ul>
    }
  </div>

  @if (options.closeButton) {
  <button
    (click)="remove()"
    class='rs-msg-handler-close-btn'
    mat-icon-button
  >
    <mat-icon>close</mat-icon>
  </button>
  }
</main>

@if (options.progressBar) {
<div>
  <div
    [style.width]="width() + '%'"
    class="toast-progress"
  ></div>
</div>
}